"use client";

import { UserDefinedRoutes } from "@/lib/routes";
import { LocalizedSlugs } from "@/lib/routing/resolve-effective-page-context";
import { createContext, useContext } from "react";

export interface UrlContextValue {
	slug: string[];
	localizedSlugs: LocalizedSlugs;
	userDefinedRoutes: UserDefinedRoutes;
	urlVariables?: Record<string, string>;
}

export const UrlContext = createContext<UrlContextValue | null>(null);

export function UrlProvider({
	children,
	slug,
	localizedSlugs,
	userDefinedRoutes,
	urlVariables,
}: {
	children: React.ReactNode;
} & UrlContextValue) {
	return <UrlContext.Provider value={{ slug, localizedSlugs, userDefinedRoutes, urlVariables: urlVariables ?? {} }}>{children}</UrlContext.Provider>;
}

export function useUrl() {
	const context = useContext(UrlContext);

	if (!context) {
		throw new Error("useUrl must be used within an UrlProvider");
	}

	return context;
}
